// extracted by mini-css-extract-plugin
export default {"shared":"\"../../shared.module.css\"","md":"768px","lg":"992px","xl":"1200px","container":"PageContainer_container__WmMRE"};